<template>
  <div :class="['upload', { 'upload-check': type === 'check' }]">
    <el-upload
      :class="[
        'upload-pdf',
        { 'no-url': !fileList.length || !fileList[0].url }
      ]"
      :accept="acceptType"
      action="/app/file/upload/file"
      multiple
      :file-list="fileList"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
    >
      <el-button size="mini" v-if="type != 'check'">
        <i class="e6-icon-upload_fill"></i>
        上传文件
      </el-button>
      <div v-if="type != 'check'" slot="tip" class="el-upload__tip">
        {{ getUploadTips() }}
      </div>
    </el-upload>
    <el-button
      type="text"
      class="pre-view"
      v-if="
        fileList.length &&
          fileList[0].url &&
          fileList[0].name.substring(
            fileList[0].name.length - 4,
            fileList[0].name.length
          ) == '.pdf'
      "
      @click="preView(fileList.length ? fileList[0].url : [])"
      >点击预览</el-button
    >
  </div>
</template>

<script>
export default {
  name: "uploadPdf",
  model: {
    prop: "list",
    event: "change"
  },
  props: {
    type: {
      type: String,
      default: "update"
    },
    acceptType: {
      type: String,
      default: ".pdf"
    },
    titleNo: {
      type: String,
      default: "1-1-"
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      fileName: "",
      isPdfType: false,
      fileList: []
    };
  },

  watch: {
    list: {
      handler(val) {
        this.fileList = val;
      },
      deep: true,
      immediate: true
    }
  },

  created() {},

  methods: {
    // PDF预览
    preView(val) {
      window.open(val);
    },
    getUploadTips() {
      let str = "";
      if (this.acceptType == ".xls,.xlsx") {
        str = `仅支持EXCEL文档`;
      }
      if (this.acceptType == ".pdf") {
        str = `仅支持PDF文档`;
      }
      if (this.acceptType == "all") {
        str = `建议上传PDF文档，也可上传压缩包、excel、word等文档`;
      }
      return str;
    },
    handleBeforeUpload(file) {
      this.isPdfType = file.type == "application/pdf" ? true : false;
      if (this.acceptType == ".xls,.xlsx") {
        let isExcel =
          file.type == "application/vnd.ms-excel" ||
          file.type ==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ? true
            : false; // application/pdf
        if (!isExcel) {
          this.$message.warning("请上传Excel文件!");
          return false;
        }
        // pdf
      } else if (this.acceptType == ".pdf") {
        let isPdf = file.type == "application/pdf" ? true : false; // application/pdf
        if (!isPdf) {
          this.$message.warning("请上传pdf文件!");
          return false;
        }
      }
      const isLt2M = file.size / 1024 / 1024 < 200;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 200MB!");
        return false;
      }
      this.fileName = file.name;
    },
    handleSuccess(res) {
      if (res.code) {
        let fileUrl = "";
        if (res.code === 1) {
          fileUrl = res.result.fileNameActive || "";
        }
        let fileType = this.list.length ? this.list[0].type : "";
        let fileId = this.list.length ? this.list[0].fileId : "";
        this.fileList = [];
        this.$nextTick(() => {
          this.fileList.push({
            fileId,
            name: this.fileName,
            type: fileType,
            url: fileUrl,
            titleNo: this.titleNo
          });
          this.$emit("change", this.fileList);
          this.$emit("uploadCallback", this.fileList);
        });
      } else {
        this.loading = false;
        this.$message.warning(res.obj.msg);
      }
    },
    handleRemove(file) {
      this.fileList = [];
      let fileId = file.fileId || "";
      this.fileList.push({
        fileId,
        name: "",
        type: file.type,
        url: ""
      });
      this.$emit("change", this.fileList);
      this.$emit("removeCallback");
    },

    handleError() {
      this.loading = false;
      this.$message.error("上传图片失败");
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .upload-pdf {
  position: relative;
  .el-upload__tip {
    position: absolute;
    top: -7px;
    left: 130px;
    color: #999;
    font-weight: normal;
  }
  &.no-url {
    .el-upload-list {
      display: none !important;
    }
  }
  .el-upload-list {
    .el-upload-list__item {
      width: 30%;
      min-width: 300px;
    }
    .el-upload-list__item-name {
      position: relative;
      font-weight: normal;
      // left: 20px;
    }
    .el-upload-list__item-status-label {
      position: absolute;
      left: -14px;
    }
  }
  .pre-view {
    position: relative;
    top: -5px;
  }
}
.upload-check {
  /deep/ .upload-pdf {
    .el-upload {
      display: none;
    }
    .el-upload-list__item {
      &:hover {
        .el-icon-close {
          display: none !important;
          opacity: 0 !important;
        }
      }
    }
  }
}
</style>
